namespace TabAurous.Common {
    export namespace StockHelperService {
        export const baseUrl = 'Common/StockHelper';


        export declare const enum Methods {

        }

    }
}
